import { BaseRouteService } from 'core/services';

class UpdateInventoryRouteService extends BaseRouteService {
	constructor() {
		super();
		this.base = 'update-inventory/';
	}

	find(filter) {
		return super.create(this.base + 'search', filter);
	}

	findGroupedInventoryLog(filter) {
		return super.create(this.base + 'inventory-log', filter);
	}

	updateInventoryForProduct = (productId, sourceOfChange) => {
		return super.update(this.base + 'update-product/{productId}/?sourceOfChange={sourceOfChange}', {
			productId,
			sourceOfChange,
		});
	};

	updateInventoryForChannel = (channelId, sourceOfChange, isMliReset) => {
		return super.update(
			this.base + 'update-channel/{channelId}/?sourceOfChange={sourceOfChange}&isMliReset={isMliReset}',
			{
				channelId,
				sourceOfChange,
				isMliReset,
			}
		);
	};

	updateInventory(sourceOfChange) {
		return super.create(this.base + 'update/?sourceOfChange={sourceOfChange}', {
			sourceOfChange,
		});
	}
}

export default UpdateInventoryRouteService;



// WEBPACK FOOTER //
// ./src/common/data/route-services/UpdateInventoryRouteService.js